export const headers = [
  "TRANSACTION ID",
  "REFERENCE NO",
  // "CUSTOMER ID",
  "SENDER LAST NAME",
  "SENDER FIRST NAME",
  "SENDER MIDDLE NAME",
  // "SENDER BUSINESS NAME",
  "SENDERS CONTACT #",
  "RECEIVERS LAST NAME",
  "RECEIVERS FIRST NAME",
  "RECEIVERS MIDDLE NAME",
  "RECEIVERS CONTACT #",
  // "RECEIVERS CITY",
  // "RECEIVERS PROVINCE",
  "CURRENCY",
  "ORIGINAL FEE",
  "ORIGINAL PRINCIPAL AMOUNT",
  "TOTAL AMOUNT",
  "DESTINATION CURRENCY",
  "DESTINATION FEE",
  "DESTINATION PRINCIPAL AMOUNT",
  "DESTINATION TOTAL AMOUNT",
];

export const headers2 = [
  "TRANSACTION ID",
  "REFERENCE NO",
  // "CUSTOMER ID",
  // "SENDER LAST NAME",
  // "SENDER FIRST NAME",
  // "SENDER MIDDLE NAME",
  "SENDER BUSINESS NAME",
  // "SENDERS CONTACT #",
  "RECEIVERS LAST NAME",
  "RECEIVERS FIRST NAME",
  "RECEIVERS MIDDLE NAME",
  "RECEIVERS CONTACT #",
  // "RECEIVERS CITY",
  // "RECEIVERS PROVINCE",
  "CURRENCY",
  "ORIGINAL FEE",
  "ORIGINAL PRINCIPAL AMOUNT",
  "TOTAL AMOUNT",
  "DESTINATION CURRENCY",
  "DESTINATION FEE",
  "DESTINATION PRINCIPAL AMOUNT",
  "DESTINATION TOTAL AMOUNT",
];

export const moneyExchangeHeaders = [
  "Invoice Number",
  "Date of Invoice",
  "Time of Invoice",
  "Sender's First Name",
  "Family Name (1) of the Sender",
  "Family Name (2) of the Sender",
  "First Name of the Beneficiary",
  "Family Name (1) of the Beneficiary",
  "Family Name (2) of the Beneficiary",
  "Address of Beneficiary",
  "Town of the Beneficiary",
  "Country of the Beneficiary",
  "Tel no. of the Beneficiary",
  "Another Tel no. of the Beneficiary",
  "Notes",
  "Number of the Correspondent Office",
  "Name of the Correspondent Office",
  "Code assigned for the specific correspondent",
  "Total Amount",
  "Currency",
  "Credit in a Bank account",
  "Name of the bank where the beneficiary has the account",
  "Address of the bank",
  "Number of the Account",
  "Validation key to check Ordering Institution",
  "Payment key known by beneficiary",
  "Type of ID document",
  "Beneficiary ID document number",
  "Code of payment point",
  "Charge",
];

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,30}$/;

export const approveHeader = [
  "No.",
  "Date",
  "Uploader",
  "Batch No.",
  "Transaction Count",
  "Total Amount",
  "Status",
  "Actions",
];

export const reprocessHeader = [
  // "REPROCESS",
  // "CUSTOMER ID",
  "REFERENCE NO",
  "RECEIVERS CONTACT #",
  "SENDER BUSINESS NAME",
  "RECEIVERS FIRST NAME",
  "RECEIVERS MIDDLE NAME",
  "RECEIVERS LAST NAME",
  "DESTINATION CURRENCY",
  "DESTINATION PRINCIPAL AMOUNT",
  "DESTINATION FEE",
];

export const bpKPXHeader = [
  "No",
  "Date / Time",
  "Control No",
  "Reference No",
  "Payor",
  "Address",
  "Account No",
  "Account Name",
  "Amount Paid",
  "Charge to Customer",
  "Charge to Partner",
  "Contact No",
  "Other Details",
  "Branch ID",
  "ML Outlet",
  "Region Code",
  "Region",
  "Operator",
  "Remote Branch",
  "Remote Operator",
  "2nd Approver",
];

export const statusOptions = [
  {
    label: "ALL",
    value: "ALL",
  },
  {
    label: "AVAILABLE",
    value: "AVAILABLE",
  },
  {
    label: "CANCELLED",
    value: "CANCELLED",
  },
  {
    label: "CLAIMED",
    value: "CLAIMED",
  },
  {
    label: "FAILED",
    value: "FAILED",
  },
  {
    label: "PENDING",
    value: "ON HOLD",
  },
];
export const systemUse = "PAYMENT SOLUTION";
